import { render, staticRenderFns } from "./EditArtworkDialog.vue?vue&type=template&id=79008c68&scoped=true"
import script from "./EditArtworkDialog.vue?vue&type=script&lang=ts"
export * from "./EditArtworkDialog.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./EditArtworkDialog.vue?vue&type=style&index=0&id=79008c68&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "79008c68",
  null
  ,true
)

export default component.exports